import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["primaryLink", "secondaryLink", "tertiaryLink", "size", "palette", "onClick"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { memo, useCallback } from 'react';
import Button, { ButtonVariant } from "../button";
import { Container } from "./action-bar.styles";
import { defaultProps } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ActionBar = function ActionBar(_ref) {
  var primaryLink = _ref.primaryLink,
    secondaryLink = _ref.secondaryLink,
    tertiaryLink = _ref.tertiaryLink,
    size = _ref.size,
    palette = _ref.palette,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var shouldRender = Boolean(primaryLink || secondaryLink || tertiaryLink);
  var handleClick = useCallback(function (link) {
    return function (event) {
      onClick === null || onClick === void 0 ? void 0 : onClick({
        link: link,
        event: event
      });
    };
  }, [onClick]);
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({}, props), {}, {
    children: [primaryLink && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      palette: palette,
      size: size
      // @ts-expect-error
      // TS2322: Type '(event: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> | undefined) => void' is not assignable to type 'MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>'.
      // Types of parameters 'event' and 'event' are incompatible.
      // Type 'MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>' is not assignable to type 'MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>'.
      // Type 'MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>' provides no match for the signature '(event: MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>): void'.  index.d.ts(1479, 9): The expected type comes from property 'onClick' which is declared here on type 'IntrinsicAttributes & Pick<ButtonProps, "onClick" | "children" | "download" | "hrefLang" | "media" | "ping" | "rel" | "target" | "type" | ... 252 more ... | "onTransitionEndCapture"> & InexactPartial<...> & InexactPartial<...>'
      ,

      onClick: handleClick(primaryLink)
    }, primaryLink), {}, {
      variant: ButtonVariant.Primary,
      children: primaryLink.label
    })), secondaryLink && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      palette: palette,
      size: size
      // @ts-expect-error
      ,

      onClick: handleClick(secondaryLink)
    }, secondaryLink), {}, {
      variant: ButtonVariant.Secondary,
      children: secondaryLink.label
    })), tertiaryLink && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      palette: palette,
      size: size
      // @ts-expect-error
      ,

      onClick: handleClick(tertiaryLink)
    }, tertiaryLink), {}, {
      variant: ButtonVariant.Tertiary,
      children: tertiaryLink.label
    }))]
  }));
};
ActionBar.defaultProps = defaultProps;
export default /*#__PURE__*/memo(ActionBar);